import { BaseError } from '@nsftx/seven-client-retail-utils'

type TicketResolveErrorType =
  | 'SGP_TICKET_NOT_FOUND'
  | 'SGP_TICKET_ALREADY_RESOLVED'
  | 'SGP_TICKET_RESOLVE_SOCKET_TIMEOUT_ERROR'
  | 'SGP_TICKET_RESOLVE_BETSLIP_HTTP_FAILED'

export default class TicketResolveError extends BaseError<TicketResolveErrorType> {
  constructor(
    public message: string,
    public code: TicketResolveErrorType,
    public options: {
      cause?: unknown
      context: {
        betslipId?: string
        feBetslipId?: string
        errorDetails?: unknown
      }
    }
  ) {
    super(message, code, options)
    Object.setPrototypeOf(this, TicketResolveError.prototype)
    this.name = this.constructor.name
  }
}
